import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { JoinContestModel, ContestSummaryModel } from '../../../models/contest';
import { ContestService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'join-contest',
    templateUrl: './join.contest.component.html'
})

export class JoinContestComponent implements OnInit {
    @BlockUI('conatiner-contest-summary') blockUI: NgBlockUI;

    modalReference: any;
    contest: ContestSummaryModel = new ContestSummaryModel();
    model: JoinContestModel = new JoinContestModel();
    tags: any = [];

    constructor(private _vcr: ViewContainerRef,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private toastr: ToastsManager,
        private contestService: ContestService,
        private appUtils: AppUtils) {

        this.toastr.setRootViewContainerRef(this._vcr);

        this.route.params.subscribe(params => {
            this.model.contestId = params['id'];
        });
    }


    ngOnInit() {
        this.blockUI.start();
        this.contestService.getSummary(this.model.contestId)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    Object.assign(this.contest, data);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
    }

    submitDesign() {
        if (this.tags && this.tags.length !== 0) {
            this.model.tags = this.tags.map((item: any) => item.value).toString();
        }

        if (!this.model.designFile) {
            this.toastr.error('Please upload design file');
            return;
        }

        if (this.contest.termAndConditions
            && !this.model.agreeToTermsAndConditions) {
            this.toastr.error('Please accept terms and conditions');
            return;
        }

        this.blockUI.start();
        this.contestService.submitContest(this.model)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.router.navigate(['/content/filter']);
                    setTimeout(() => {
                        this.toastr
                            .success(`Your design has been submitted successfully.
                            Submission will be visible, if accepted, within 24 hours`);
                    }, 500);

                },
                (error: any) => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
    }

    onFileSelected(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files.item(0);
            if (file == null) {
                this.toastr.error('Please select a valid image file.');
                return;
            }
            this.blockUI.start();
            this.contestService.uploadDesignFile(this.model.contestId, file).subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.model.designFile = data.fileKey;
                    this.model.designFileUrl = data.fileUrl;
                    this.toastr.success('Design file has been uploaded successfully.');
                },
                (error: any) => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
        }
    }

    resetForm() {
        this.model = new JoinContestModel();
        this.tags = [];
    }

    openTermsAndConditionsDialog(content: any) {
        this.modalReference = this.modalService.open(content, { size: 'lg' });
    }

    closeTermsAndConditionsDialog() {
        this.modalReference.close();
    }
}



// WEBPACK FOOTER //
// ./src/components/contest/join-contest/join.contest.component.ts